exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.card-image-container[data-v-15f2c849]{min-height:150px;max-height:150px;min-width:235px\n}\n.card-body[data-v-15f2c849]{max-width:235px;max-height:251px;min-height:251px;padding:0;display:flex;flex-direction:column;justify-content:space-between;cursor:pointer\n}\n.card-body .card-content[data-v-15f2c849]{flex-direction:column;overflow:hidden\n}\n.card-body .green-band[data-v-15f2c849]{background:#a3b266;padding:0;margin-top:0 !important;max-height:27px;color:#fff;justify-content:space-between\n}\n.card-body .green-band>.avatar-holder[data-v-15f2c849]{text-align:right;margin-top:-15px;display:inline\n}", ""]);

// exports
